import { BaseService } from '@services/BaseService';
import { OptionsViewModel, PageViewModel } from '@models/common.models';
import { TransactionCoordinatorViewModel, TransactionCoordinatorSearchViewModel } from '@models/TransactionCoordinator';

class TransactionCoordinatorService extends BaseService {
  constructor() {
    super('transaction-coordinators');
  }

  public async saveTransactionCoordinator(model: TransactionCoordinatorViewModel): Promise<number> {
    if (model.id === 0) {
      const vm = await this.fetch<TransactionCoordinatorViewModel>('', {
        method: 'POST',
        body: JSON.stringify(model)
      });
      return vm.id;
    } else {
      const vm = await this.fetch<TransactionCoordinatorViewModel>(`${model.id}`, {
        method: 'PUT',
        body: JSON.stringify(model)
      });
      return vm.id;
    }
  }

  getTransactionCoordinator(id: number) {
    return this.fetch<TransactionCoordinatorViewModel>(`${id}`, {
      method: 'GET'
    });
  }

  getTransactionCoordinatorTypes() {
    return this.fetch<OptionsViewModel[]>('types', {
      method: 'GET'
    });
  }

  getTransactionCoordinatorStatuses() {
    return this.fetch<OptionsViewModel[]>('statuses', {
      method: 'GET'
    });
  }

  searchTransactionCoordinators(query?: string, id?: number) {
    return this.fetch<PageViewModel<TransactionCoordinatorSearchViewModel>>('search', {
      method: 'POST',
      body: JSON.stringify({ query: query, id: id })
    });
  }

  searchTransactionCoordinatorsFull(
    query: string | null,
    pageSize?: number,
    page?: number,
    orderBy?: string,
    orderDirection?: string
  ) {
    return this.fetch<PageViewModel<TransactionCoordinatorSearchViewModel>>('search', {
      method: 'POST',
      body: JSON.stringify({
        query: query,
        pageSize: pageSize,
        pageNumber: page,
        orderBy: orderBy,
        orderDirection: orderDirection
      })
    });
  }
}

export const transactionCoordinatorService = new TransactionCoordinatorService();



// WEBPACK FOOTER //
// ./src/_services/TransactionCoordinatorService.ts